var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25C10.116 2.25 6.75 5.616 6.75 9.75C6.75 11.5463 7.38 13.1925 8.4375 14.4847L2.46075 20.46L3.54 21.54L9.516 15.5632C10.8506 16.6576 12.5241 17.2538 14.25 17.25C18.384 17.25 21.75 13.884 21.75 9.75C21.75 5.616 18.384 2.25 14.25 2.25ZM14.25 3.75C17.5725 3.75 20.25 6.4275 20.25 9.75C20.25 13.0725 17.5725 15.75 14.25 15.75C10.9275 15.75 8.25 13.0725 8.25 9.75C8.25 6.4275 10.9275 3.75 14.25 3.75Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaSearch);
export default __webpack_public_path__ + "static/media/la_search.791c71e75f3a633641fe47d3dc9fb397.svg";
export { ForwardRef as ReactComponent };